import ProgressBar from 'carbon-components-react/lib/components/ProgressBar';
import { QuestionInterface } from 'src/apps/leadership-assessment/lib/type';
import './DropQuestion.scss';
import { Button, Select, SelectItem } from 'carbon-components-react';
import { useContext, useEffect, useState } from 'react';
import { ArrowRight20 } from '@carbon/icons-react';
import { layoutContext } from '../../LeaderAssesssment';

interface questionsProps {
  contents: QuestionInterface;
  totalOfQuestions: any;
  qNextBtn: object;
}

const DropQuestion = (questionsProps: questionsProps) => {
  const { contents, totalOfQuestions, qNextBtn } = questionsProps;
  const [selectedOptions, setSelectedOptions]: any = useState({});
  const { currentQuestion, setScore, score, setCurrentQuestion } =
    useContext(layoutContext);

  useEffect(() => {
    const initialSelected: any = {};
    contents.options.forEach((option: any) => {
      const { degree } = contents;
      if (degree) {
        initialSelected[option.copy.props.defaultMessage] =
          option.value * degree[0].value;
      }

      setSelectedOptions(initialSelected);
    });
  }, []);

  const handleChange = (option: any, value: any, selected: any) => {
    setSelectedOptions({ ...selected, [option]: value });
  };

  const handleNext = (currentNumber: number, currentScore: number) => {
    const scores = Object.values(selectedOptions);
    let totalScoresTable = 0;
    scores.forEach((value: any) => {
      totalScoresTable += parseFloat(value);
    });

    setScore(currentScore + totalScoresTable);
    setCurrentQuestion((currentNumber += 1));
  };

  return (
    <div className="leadership-assesssment__drop-question bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
      <ProgressBar
        label={`${contents.questionNumber} of ${totalOfQuestions - 1}`}
        value={(contents.questionNumber - 1) / totalOfQuestions}
        max={1}
        className="leadership-assesssment__drop-question-progress bx--col-sm-4"
      />
      <h1 className="leadership-assesssment__drop-question-title bx--col-sm-4">{`${contents.questionNumber}. ${contents.title.props.defaultMessage}`}</h1>
      <div className="leadership-assesssment__drop-question-container bx--col-sm-4">
        {contents.options.map((option: any, i: number) => {
          return (
            <Select
              id={'select' + i}
              labelText={option.copy.props.defaultMessage}
              onChange={(e: any) =>
                handleChange(
                  option.copy.props.defaultMessage,
                  e.target.value,
                  selectedOptions,
                )
              }
            >
              {contents.degree?.map((individualDegree) => {
                return (
                  <SelectItem
                    value={individualDegree.value * option.value}
                    text={individualDegree.copy.props.defaultMessage}
                  />
                );
              })}
            </Select>
          );
        })}
      </div>
      <div className="leadership-assesssment__question-btn-container">
        <Button
          className="leadership-assesssment__question-btn"
          onClick={() => handleNext(currentQuestion, score)}
        >
          {qNextBtn}
          <ArrowRight20 />
        </Button>
      </div>
    </div>
  );
};

export default DropQuestion;
